/*
 * @Author: Tina Huang
 * @Date: 2024-02-20 09:53:38
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-08-31 00:18:57
 * @Description:
 */
import { useEffect, useState } from 'react'
import { Card, Tooltip, Button, Tag } from 'antd'
import { CopyrightCircleOutlined, CopyOutlined, ShareAltOutlined, ShoppingCartOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import NotifyCard from './Notify'
import { checkVIP } from '@/utils'
import Gift from '@/assets/svgs/gift'

export const useOffStatus = (item: any) => {
  const [offStatus, setOffStatus] = useState({
    status: '',
    off: 0,
    pay: 0,
    realPrice: 0,
  })

  useEffect(() => {
    if (!item) return
    const { pay, off, off_date } = item,
      initStatus = {
        status: '',
        off,
        pay,
        realPrice: 0,
      }
    if (off) {
      let _off = off
      if (!off_date) {
        // 不过期
        initStatus['status'] = 'never'
      } else {
        const r_off_date = new Date(off_date)
        if (r_off_date.getTime() > Date.now()) {
          // 未到期
          initStatus['status'] = 'pending'
        } else {
          // 优惠已过期
          initStatus['status'] = ''
          _off = 0
        }
      }
      initStatus['realPrice'] = Math.round((pay - _off) * 100) / 100
    }
    setOffStatus(initStatus)
  }, [item])

  return { offStatus }
}

export default function LibItem(props: { item: any; from?: string; onShowBind?: () => void }) {
  const { item, from, onShowBind } = props
  const navigate = useNavigate()
  const { offStatus } = useOffStatus(item)
  const isMobile = window.innerWidth <= 750

  const handleClick = () => {
    if (from === 'vip' && !checkVIP()) {
      // 验证绑定信息
      onShowBind?.()
      return
    }

    // window?.splitbee.track('View template', {
    //   id: item?.id,
    //   title: item?.title,
    // })
    if (item?.extra_link) {
      return window.open(item.extra_link)
    }
    navigate(from === 'vip' ? `/vpicks-detail/${item.id}` : `/picks-detail/${item.id}`)
  }

  const ExtraTag = (props: { type: string }) => {
    const { type } = props
    const { status, pay, realPrice } = offStatus

    return (
      <>
        {type === 'title' && item?.code && !item.pay && (
          <Tag bordered={false} color="gold">
            限定分享
          </Tag>
        )}
        {type === 'title' && status === 'pending' && <Tag color="#cd201f">限时优惠</Tag>}
        {type === 'title' && status === 'never' && <Tag color="#cd201f">超级优惠</Tag>}
        {type === 'price' && pay && status !== 'pending' && status !== 'never' && (
          <Tag bordered={false} color="volcano" className="text-sm">
            {pay ? `¥ ${pay}${item.has_specs ? ' 起' : ''}` : ''}
          </Tag>
        )}
        {type === 'price' && pay && (status === 'pending' || status === 'never') && (
          <>
            <Tag bordered={false} color="volcano" className="text-sm">
              {`¥ ${realPrice}`}
            </Tag>
            <span className="line-through">¥{pay}</span>
          </>
        )}
      </>
    )
  }
  const CardTitle = () => (
    <>
      {!isMobile && (
        <>
          <ExtraTag type="title" />{' '}
        </>
      )}
      {item?.title}
    </>
  )

  return (
    <>
      {item.title === '重要通知' && from !== 'vip' && <NotifyCard />}
      {item.title !== '重要通知' && (
        <Card
          className='pick-item'
          hoverable
          style={{ width: isMobile ? '99%' : 300, marginTop: 16 }}
          cover={
            <div className="relative">
              {!item.pay && (
                <Tag color="#cd201f" className="absolute left-1 top-1">
                  免费
                </Tag>
              )}
              {!isMobile && item?.pay !== 0 && item?.has_specs && item.specs[0].price === 0 && (
                <Tag color="#cd201f" className="absolute left-1 top-1">
                  含试用
                </Tag>
              )}
              {!isMobile && item?.lasted && (
                <Tag color="#cd201f" className="absolute left-1 top-1">
                  最新
                </Tag>
              )}
              <img alt="example" src={item && item.cover} />
            </div>
          }
          onClick={handleClick}
          actions={[
            <>
              {item?.pay > 0 && <ExtraTag type="price" />}
              {(!item?.pay || item?.pay <= 0) && (
                <Tooltip title="阿汪同学原创">
                  <CopyrightCircleOutlined key="copyright" />
                </Tooltip>
              )}
            </>,
            <>
              {isMobile && (
                <>
                  <Button
                    disabled={item?.lock}
                    onClick={handleClick}
                    shape="round"
                    icon={item?.activity ? <Gift /> : item?.pay ? <ShoppingCartOutlined /> : <CopyOutlined />}
                    size="small"
                  />
                </>
              )}
              {!isMobile && (
                <>
                  {from === 'vip' && (
                    <Button type="primary" shape="round" icon={<ShareAltOutlined />} onClick={handleClick}>
                      {'我要拷贝'}
                    </Button>
                  )}
                  {from !== 'vip' && (
                    <Button
                      type="primary"
                      shape="round"
                      icon={item?.activity ? <Gift /> : <ShareAltOutlined />}
                      disabled={item?.lock}
                      onClick={handleClick}
                    >
                      {item?.lock ? '已锁定' : item?.pay ? '去购买' : '去拷贝'}
                    </Button>
                  )}
                </>
              )}
            </>,
            // <Tooltip title="直接拷贝组件链接">
            //   <CopyOutlined key="copy" />
            // </Tooltip>,
          ]}
        >
          <Card.Meta title={<CardTitle />} description={isMobile ? '' : item?.keywords?.join('｜')} />
        </Card>
      )}
    </>
  )
}
